var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1853 2.25H7.85959C7.74219 2.2499 7.62592 2.27293 7.51742 2.31777C7.40891 2.3626 7.31031 2.42837 7.22722 2.51132C7.14414 2.59426 7.0782 2.69276 7.03318 2.80119C6.98816 2.90962 6.96494 3.02585 6.96484 3.14325V7.125L15.2666 9.5625L23.0808 7.125V3.14325C23.0807 3.02579 23.0575 2.90949 23.0124 2.80102C22.9674 2.69254 22.9014 2.59401 22.8182 2.51105C22.735 2.4281 22.6363 2.36234 22.5278 2.31755C22.4192 2.27276 22.3028 2.2498 22.1853 2.25Z",
    fill: "#41A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0808 7.125H6.96484V12L15.2666 13.4625L23.0808 12V7.125Z",
    fill: "#2B7CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96484 12V16.875L14.7783 17.85L23.0808 16.875V12H6.96484Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85959 21.75H22.1846C22.3021 21.7503 22.4186 21.7274 22.5272 21.6827C22.6359 21.6379 22.7347 21.5722 22.8179 21.4892C22.9012 21.4062 22.9672 21.3077 23.0124 21.1992C23.0575 21.0906 23.0807 20.9743 23.0808 20.8568V16.875H6.96484V20.8568C6.96494 20.9742 6.98816 21.0904 7.03318 21.1988C7.0782 21.3072 7.14414 21.4057 7.22722 21.4887C7.31031 21.5716 7.40891 21.6374 7.51742 21.6822C7.62592 21.7271 7.74219 21.7501 7.85959 21.75Z",
    fill: "#103F91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.9063 6.15039H6.96484V18.3379H12.9063C13.1431 18.3367 13.3698 18.2423 13.5375 18.0751C13.7051 17.9079 13.8001 17.6814 13.8018 17.4446V7.04364C13.8001 6.80689 13.7051 6.58038 13.5375 6.41318C13.3698 6.24598 13.1431 6.15157 12.9063 6.15039Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.4181 6.6377H6.96484V18.8252H12.4181C12.6548 18.824 12.8816 18.7296 13.0492 18.5624C13.2168 18.3952 13.3118 18.1687 13.3136 17.9319V7.53095C13.3118 7.2942 13.2168 7.06769 13.0492 6.90049C12.8816 6.73329 12.6548 6.63887 12.4181 6.6377Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.4181 6.6377H6.96484V17.8502H12.4181C12.6548 17.849 12.8816 17.7546 13.0492 17.5874C13.2168 17.4202 13.3118 17.1937 13.3136 16.9569V7.53095C13.3118 7.2942 13.2168 7.06769 13.0492 6.90049C12.8816 6.73329 12.6548 6.63887 12.4181 6.6377Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.9298 6.6377H6.96484V17.8502H11.9298C12.1666 17.849 12.3933 17.7546 12.561 17.5874C12.7286 17.4202 12.8236 17.1937 12.8253 16.9569V7.53095C12.8236 7.2942 12.7286 7.06769 12.561 6.90049C12.3933 6.73329 12.1666 6.63887 11.9298 6.6377Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97558 6.6377H11.9291C12.1663 6.6375 12.3938 6.73147 12.5617 6.89897C12.7296 7.06646 12.8242 7.29377 12.8246 7.53095V16.4694C12.8242 16.7066 12.7296 16.9339 12.5617 17.1014C12.3938 17.2689 12.1663 17.3629 11.9291 17.3627H2.97558C2.85811 17.3629 2.74176 17.3399 2.63317 17.2951C2.52458 17.2504 2.42588 17.1846 2.34272 17.1016C2.25956 17.0187 2.19355 16.9202 2.14849 16.8117C2.10342 16.7032 2.08018 16.5869 2.08008 16.4694V7.53095C2.08018 7.41348 2.10342 7.29719 2.14849 7.18871C2.19355 7.08023 2.25956 6.9817 2.34272 6.89875C2.42588 6.81579 2.52458 6.75004 2.63317 6.70525C2.74176 6.66045 2.85811 6.6375 2.97558 6.6377Z",
    fill: "url(#paint0_linear_1755_2198)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75516 13.491C5.77241 13.629 5.78441 13.749 5.78966 13.8517H5.81066C5.81816 13.7542 5.83466 13.6365 5.85941 13.4992C5.88416 13.362 5.90591 13.2457 5.92616 13.1505L6.86741 9.09522H8.08541L9.06041 13.0897C9.1172 13.3368 9.15778 13.5873 9.18191 13.8397H9.19841C9.21632 13.594 9.25014 13.3498 9.29966 13.1085L10.0789 9.08997H11.1867L9.81866 14.901H8.52341L7.59566 11.0565C7.56866 10.9455 7.53816 10.801 7.50416 10.623C7.47016 10.445 7.44916 10.315 7.44116 10.233H7.42541C7.41491 10.3275 7.39391 10.4677 7.36241 10.6537C7.33091 10.8405 7.30616 10.9777 7.28741 11.0677L6.41516 14.9032H5.09816L3.72266 9.09522H4.84766L5.69591 13.1587C5.72122 13.2684 5.741 13.3793 5.75516 13.491Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1755_2198",
    x1: 3.95058,
    y1: 5.9357,
    x2: 10.9541,
    y2: 18.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordDoc);
export default __webpack_public_path__ + "static/media/word-doc.7a679da4507e9f3d617ad77cf2b3abfc.svg";
export { ForwardRef as ReactComponent };